import * as R from "ramda";
import ReactGA from "react-ga4";
var report = R.curry(function(action, label) {
    var _localStorage_getItem;
    return ReactGA.event({
        action: action,
        category: (_localStorage_getItem = localStorage.getItem("vch.app_name")) !== null && _localStorage_getItem !== void 0 ? _localStorage_getItem : "-",
        label: label !== null && label !== void 0 ? label : ""
    });
});
var GAEvents = {
    buyNumber: report("Buy phone number"),
    createProduct: report("Create Product"),
    createProductVersion: report("Create Product Version"),
    createWorkspace: report("Create Workspace"),
    deleteInstance: report("Delete Instance"),
    deleteProduct: report("Delete Product"),
    deleteWorkspace: report("Delete Workspace"),
    deployInstance: report("Deploy Instance"),
    deployProduct: report("Deploy Product"),
    editProductVersion: report("Edit Product Version"),
    filterData: report("Filter data"),
    importSourceCodeFromArchive: report("Import Source Code from Archive"),
    importSourceCodeFromWorkspace: report("Import Source Code from Workspace"),
    launchWorkspace: report("Launch Workspace"),
    login: function(method) {
        return ReactGA.event("login", {
            method: method
        });
    },
    logout: function(method) {
        return ReactGA.event("logout", {
            method: method
        });
    },
    publishProduct: report("Publish Product"),
    releaseVersion: report("Release Version"),
    renameWorkspace: report("Rename Workspace"),
    search: function(search_term) {
        return ReactGA.event("search", {
            search_term: search_term
        });
    },
    signUp: function(method) {
        return ReactGA.event("signUp", {
            method: method
        });
    },
    submitVersionForReview: report("Submit Version for review")
};
export default GAEvents;

//# sourceMappingURL=ga-events.js.map